<!--begin::Body-->
<div class="kt-login__body auth-right">
	<!--begin::Signin-->
	<div class="customer-logo w-470">
		<img [src]="imagePaths.uptimeLogoOriginal" *ngIf="!isLogoAvailable" alt="uptime-logo" width="75em" />
		<img [src]="isLogoAvailable" *ngIf="isLogoAvailable" width="75em" alt="logo" />
	</div>
	<div class="kt-login__form form-body">
				<div class="kt-login__title margin-0 w-470 d-flex align-items-center justify-content-center">
					<h5 class="sign-in-text">{{ 'AUTH.REGISTER.TITLE' | translate }}</h5>
				</div>

		<kt-auth-notice></kt-auth-notice>

		<form class="kt-login__form kt-form margin-0 w-470" [formGroup]="registerForm" autocomplete="off">
			<div class="form-group form-entity d-flex flex-column pad-b-14">
				<kt-input
					[label]="'AUTH.REGISTER.ORGANIZATION_NAME' | translate"
					[placeholder]="'AUTH.REGISTER.ORGANIZATION_NAME' | translate"
					formControlName="organization"
					(inputBlur)="updateErrors()"
					[errorMessage]="organizationErrorMessage">
				</kt-input>
			</div>
			<div class="form-group form-entity d-flex flex-column pad-b-14">
				<kt-input
					[label]="'AUTH.REGISTER.NAME' | translate"
					[placeholder]="'AUTH.REGISTER.NAME' | translate"
					formControlName="name"
					(inputBlur)="updateErrors()"
					[errorMessage]="nameErrorMessage">
				</kt-input>
			</div>
			<div class="form-group form-entity d-flex flex-column pad-b-14">
				<kt-input
					[label]="'AUTH.INPUT.EMAIL' | translate"
					[placeholder]="'AUTH.INPUT.EMAIL' | translate"
					formControlName="email"
					(inputBlur)="updateErrors()"
					[errorMessage]="emailErrorMessage">
				</kt-input>
			</div>
			<!-- <div class="form-group">
				<mat-form-field>
					<mat-label>Username</mat-label>
					<input matInput type="text" placeholder="Username" formControlName="username" />
					<mat-error *ngIf="isControlHasError('username','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('username','minlength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('username','maxlength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
					</mat-error>
				</mat-form-field>
			</div> -->
			<div class="form-group form-entity d-flex flex-column pad-b-14">
				<kt-input
					type="password"
					[label]="'AUTH.INPUT.PASSWORD' | translate"
					[placeholder]="'AUTH.INPUT.PASSWORD' | translate"
					formControlName="password"
					(inputBlur)="updateErrors()"
					[errorMessage]="passwordErrorMessage">
				</kt-input>
				<kt-password-requirements *ngIf="registerForm.get('password')?.dirty" [password]="registerForm.get('password')?.value"></kt-password-requirements>
			</div>
			<div class="form-group form-entity d-flex flex-column pad-b-14">
				<kt-input
					type="password"
					[label]="'AUTH.INPUT.CONFIRM_PASSWORD' | translate"
					[placeholder]="'AUTH.INPUT.CONFIRM_PASSWORD' | translate"
					formControlName="confirmPassword"
					(inputBlur)="updateErrors()"
					[errorMessage]="confirmPasswordErrorMessage">
				</kt-input>
			</div>
			<div class="d-flex justify-content-between">
				<mat-checkbox name="agree" formControlName="agree">
					{{ 'AUTH.REGISTER.AGREE_PREFIX' | translate }} <a class="link-underline" href="javascript:;">{{ 'AUTH.REGISTER.TERMS_CONDITIONS' | translate }}</a>
				</mat-checkbox>
				<a href="javascript:;" routerLink="/web/forgot-password" class="kt-link kt-login__link-forgot forgot-password-text">
					{{ 'AUTH.GENERAL.FORGOT_BUTTON' | translate }}
				</a>
			</div>
			<div class="my-5">
				<kt-button-v1
					variant="flat"
					class="auth-btn w-100"
					[fullWidth]="true"
					(btnClick)="submit()"
					[label]="'AUTH.GENERAL.SUBMIT_BUTTON' | translate"
					[disabled]="loading"
					[style.--auth-bg]="loading ? '#8B8B8D' : '#6340D5'"
					[loading]="loading">
				</kt-button-v1>
			</div>
			<!--end::Action-->
				<div class="signup-head my-5 pb-5">
					<span class="signup-label kt-login__signup-label">{{ 'AUTH.GENERAL.HAVE_ACCOUNT' | translate }} </span>&nbsp;&nbsp;
					<a href="javascript:;" routerLink="/web/login" id="kt_login_signup_cancel" class="kt-link kt-login__signup-link link-underline fw-400">{{ 'AUTH.LOGIN.BUTTON' | translate }}</a>
				</div>
		</form>
	</div>
</div>